import Konva from 'konva';
import React from 'react';
import AdminConfig from '../classes/AdminConfig';
import ClientConfig from '../classes/ClientConfig';
import _Node from '../classes/konva/_Node';
import loadingLogo from '../loading.gif'
import styled from 'styled-components';
import ClassConfigurator from '../classes/ClassConfigurator';


const LoadingImg = styled.img`
  position:       absolute;
  left:           0; 
  right:          0;
  top:            0;
  bottom:         0;
  margin-left:    auto; 
  margin-right:   auto;
  margin-top:     auto;
  margin-bottom:  auto;
  width:          100px;
  visibility:     ${props => props.creatorVisibility ? "hidden" : "visible"};
`;

const CreatorWrapper = styled.div`
  display:        flex;
  visibility:     ${props => props.creatorVisibility ? "visible" : "hidden"};
  width:          100%;
  height:         100%;
`;
    const ScrollFix = styled.div`
      z-index: 1;
      position: absolute;
      width: 100%;
      height: 100%;
    `;

class Creator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sceneWidth: 1000,
      sceneHeight: 1000,
      projects: {},
      stages: {},
      konvaContainerId: (this.props.konvaContainerIdrefix ? this.props.konvaContainerIdrefix + 'konvaContainer' : "konvaContainer"),
      admin: false,
      customerImageLayers: [],
      creatorVisibility: false,
    };
    this.fitStagesIntoParentContainer = this.fitStagesIntoParentContainer.bind(this);
    this.addResizeEvent = this.addResizeEvent.bind(this);
    this.build = this.build.bind(this);
    this.loadContent = this.loadContent.bind(this);
  }

  componentDidMount() {
    this.build();
  }

  build() {
    ClassConfigurator.configureClasses();
    let stage = Konva._Node.create(this.props.project.creator_data, this.state.konvaContainerId + this.props.index);
    let config;

    if (!this.state.admin)
      config = new ClientConfig({ stage: stage, project: this.props.project });
    else
      config = new AdminConfig({ stage: stage, project: this.props.project });

    this.loadContent(stage);
    this.props.project.stage = stage;
    this.state.projects[this.props.index] = this.props.project;
    this.fitStagesIntoParentContainer();
    this.addResizeEvent();
  }

  loadContent(stage) {
    let promises = [];
    stage.getLayers().forEach(layer => {
      let objectType = layer.getAttr('object_type');
      if (['image', 'product', 'text_normal', 'ellipse'].includes(objectType)) {
        let content = layer.findOne('.content');
        promises.push(
          new Promise((resolve, reject) => {
            content.load(resolve, reject);
          })
        );
      }
    });

    Promise.all(promises)
      .then((values) => {
        stage.draw();
        this.setState({
          creatorVisibility: true
        });
        this.props.setClientCustomizationVisible();
      })
  }

  addResizeEvent() {
    window.addEventListener('resize', this.fitStagesIntoParentContainer);
  }

  fitStagesIntoParentContainer(e) {
   setTimeout(() => {
      let container = document.querySelector('#' + this.state.konvaContainerId + this.props.index);
      let scale = container.offsetWidth / this.state.sceneWidth;
      this.state.projects[this.props.index].stage.width(this.state.sceneWidth * scale);
      this.state.projects[this.props.index].stage.height(this.state.sceneHeight * scale);
      this.state.projects[this.props.index].stage.scale({ x: scale, y: scale });
   }, 50);
  }

  render() {
    const { konvaContainerId, creatorVisibility } = this.state;
    const { index } = this.props;
    const id = konvaContainerId + index;

    return (
      <>
        {/* 
        It's because there is a problem with page scroll
        when we start touch on canvas, so we cover
        canvas with div element (<ScrollFix>) :)
        */}
        <ScrollFix/>
          <LoadingImg src={loadingLogo} creatorVisibility={creatorVisibility}/>
          <CreatorWrapper 
            id={id}
            creatorVisibility={creatorVisibility}
          />
      </>
    );
  }
}

export default Creator;